import React from 'react';
import styled from 'styled-components';
import { GameStatus } from '@containers';
import { Button, Fog } from '@components';
import { mapping } from './assets';

export type ResultViewClickType = 'restart' | 'continue' | 'lobby';

export interface ResultViewProps {
  status: GameStatus;
  score: number;
  speed: number;
  distance: number;
  handlerClick: (type: ResultViewClickType) => void;
}

const StyledResultView = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.95);
`;

const Title = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.header}px;
  box-sizing: border-box;
  padding: 60px 60px 0;
`;

const Score = styled.div`
  position: relative;
  font-size: 170px;
  padding-left: 220px;
`;

const Money = styled.img`
  position: absolute;
  left: -160px;
  top: -145px;
`;

const Total = styled.div`
  display: flex;
  column-gap: 70px;
  width: 430px;
  font-size: 54px;
  color: #6A6E75;
  margin-bottom: 100px;
`;

const Speed = styled.div`
  flex: 1 1 100%;
`;

const Distance = styled.div`
  text-align: right;
  flex: 1 1 100%;
`;

const StyledButton = styled(Button)`
  margin-bottom: 50px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ResultView: React.FC<ResultViewProps> = ({ status, score, speed, distance, handlerClick}) => (
  <StyledResultView>
    <Title>{status === 'game-over' ? 'Game Over' : 'Pause'}</Title>
    <Score>
      <Money src={mapping.money['1x']} srcSet={`${mapping.money['2x']} 2x`} />
      {String(score).padStart(3, '0')}
    </Score>
    <Total>
      <Speed>
        Speed x{speed}
      </Speed>
      <Distance>
        {String(distance).padStart(4, '0')} m
      </Distance>
    </Total>
    <StyledButton
      textSize={125}
      handleClick={() => handlerClick('restart')}
    >
      Restart
    </StyledButton>
    <StyledButton
      textSize={125}
      handleClick={() => handlerClick(status === 'pause' ? 'continue' : 'lobby')}
    >
      {status === 'game-over' ? 'Lobby' : 'Continue'}
    </StyledButton>
    <Fog />
  </StyledResultView>
);
